import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { ClusterClient, clusterApiRef } from './api/ClusterApi';

export const clusterPlugin = createPlugin({
  id: 'cluster',
  routes: { root: rootRouteRef },
  apis: [
    createApiFactory({
      api: clusterApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ClusterClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/** The cluster inventory, mounted at /clusters. */
export const ClusterPage = clusterPlugin.provide(
  createRoutableExtension({
    name: 'ClusterPage',
    component: () => import('./components/ClusterPage').then(m => m.ClusterPage),
    mountPoint: rootRouteRef,
  }),
);
